import { SEARCH_BY_NAME_OPEN_PARAM } from '@rover/react-lib/src/pages/search/SearchPage/components/SearchByName/constants';
import { getURL } from '@rover/shared/js/utils/getFullUrl';
import { getReferrer } from '@rover/shared/js/utils/referrer';

import { DATE_SELECTION_PARAMS } from '../SitterProfilePage/hooks/useUpdateSelectedDates';

const SEARCH_URL_PARAMS = ['service_type', 'location_type', 'location', 'pet_type'];

const getBackToSearchUrl = (searchParams: URLSearchParams): URL | string => {
  try {
    const referrerUrl = getReferrer();
    if (referrerUrl) {
      const currentURL = getURL();
      const isSameOrigin = referrerUrl.origin === currentURL.origin;
      if (isSameOrigin && referrerUrl.pathname.includes('/search')) {
        // Drop the overlay param (leaks in via referrer) so it doesn't re-open on return
        referrerUrl.searchParams.delete(SEARCH_BY_NAME_OPEN_PARAM);
        // The referrer is captured at the profile's initial load, so it predates any
        // dates picked on the profile since; overlay those from the live searchParams.
        DATE_SELECTION_PARAMS.forEach((param) => {
          const value = searchParams.get(param);
          if (value) referrerUrl.searchParams.set(param, value);
          else referrerUrl.searchParams.delete(param);
        });
        return referrerUrl;
      }
    }
    if (SEARCH_URL_PARAMS.some((param) => searchParams.get(param) !== null)) {
      return `/search/?${searchParams.toString()}`;
    }
  } catch (e) {
    // If URL parsing fails, fall back to default search
  }

  return '/search/';
};

export default getBackToSearchUrl;
